import {
  LoadingSpinner,
  Modal,
  TabsGeneric,
} from '@rabbit/elements/shared-components';
import UpdateClaimDetailsForm, {
  ClaimDetailsFormShape,
} from '../forms/UpdateClaimDetailsForm/UpdateClaimDetailsForm';
import { ModalSettingsShape } from '@rabbit/elements/shared-components';
import { CaseflowContext } from '../../../context/CaseflowContext';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileStorageContext } from '@rabbit/bizproc/react';
import ClaimAttachmentsUpload from '../ClaimAttachmentsUpload/ClaimAttachmentsUpload';
import UpdateCustomerDetailsForm from '../forms/UpdateCustomerDetailsForm/UpdateCustomerDetailsForm';
import { AppContext } from '@rabbit/app-context';
import {
  Config_UpdateClaimDetails_AttachmentsFormType,
  Config_UpdateClaimDetails_ClaimDetailsFormType,
  Config_UpdateClaimDetails_CustomerFormType,
} from 'libs/configs/src/types/config-types';

export interface ModalEditClaimDetailsProps {
  modalSettings: ModalSettingsShape;
  claimDetails: any;
  handleClose: () => void;
}

export interface SharedValuesShape {
  claimDetails: ClaimDetailsFormShape;
}

function ModalEditClaimDetails({
  claimDetails,
  handleClose,
}: ModalEditClaimDetailsProps) {
  const { config } = useContext(AppContext);
  const { caseFlowCase } = useContext(CaseflowContext) || {};
  const [sharedValues, setSharedValues] = useState<SharedValuesShape>(
    {} as any
  );
  const { unusedCompletedCleanup } = useContext(FileStorageContext) || {};

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      unusedCompletedCleanup?.();
    };
  }, []);

  if (!caseFlowCase) return <LoadingSpinner size="xs" />;

  const renderCustomerDetails = (
    type: Config_UpdateClaimDetails_CustomerFormType
  ) => {
    if (type === Config_UpdateClaimDetails_CustomerFormType.NONE) return null;

    if (type === Config_UpdateClaimDetails_CustomerFormType.DEFAULT)
      return (
        <UpdateCustomerDetailsForm
          claimDetails={claimDetails}
          handleClose={handleClose}
          caseFlowCase={caseFlowCase}
          setLoading={setLoading}
        />
      );
  };

  const renderClaimDetails = (
    type: Config_UpdateClaimDetails_ClaimDetailsFormType
  ) => {
    if (type === Config_UpdateClaimDetails_ClaimDetailsFormType.NONE)
      return null;

    return (
      <UpdateClaimDetailsForm
        claimDetails={claimDetails}
        handleClose={handleClose}
        caseFlowCase={caseFlowCase}
        setLoading={setLoading}
        sharedValues={sharedValues}
        setSharedValues={setSharedValues}
        type={type}
      />
    );
  };

  const renderAttachements = (
    type: Config_UpdateClaimDetails_AttachmentsFormType
  ) => {
    if (type === Config_UpdateClaimDetails_AttachmentsFormType.NONE)
      return null;
    if (type === Config_UpdateClaimDetails_AttachmentsFormType.DEFAULT)
      return <ClaimAttachmentsUpload handleClose={handleClose} />;
  };

  function generateTabs() {
    const tabs = [];

    if (
      config?.CLAIMS?.CLAIM_DETAIL_VIEW.UPDATE_CLAIM_DETAILS
        .CUSTOMER_DETAILS !== 'NONE'
    ) {
      tabs.push({
        label: t('general.customerDetails'),
        children: renderCustomerDetails(
          config?.CLAIMS?.CLAIM_DETAIL_VIEW.UPDATE_CLAIM_DETAILS
            .CUSTOMER_DETAILS
        ),
      });
    }

    if (
      config?.CLAIMS?.CLAIM_DETAIL_VIEW.UPDATE_CLAIM_DETAILS.CLAIM_DETAILS !==
      'NONE'
    ) {
      tabs.push({
        label: t('general.claimDetails'),
        children: renderClaimDetails(
          config?.CLAIMS?.CLAIM_DETAIL_VIEW.UPDATE_CLAIM_DETAILS.CLAIM_DETAILS
        ),
      });
    }

    // if (
    //   config?.CLAIMS?.CLAIM_DETAIL_VIEW.UPDATE_CLAIM_DETAILS.ATTACHMENTS !==
    //   'NONE'
    // ) {
    //   tabs.push({
    //     label: t('Attachments'),
    //     children: renderAttachements(
    //       config?.CLAIMS?.CLAIM_DETAIL_VIEW.UPDATE_CLAIM_DETAILS.ATTACHMENTS
    //     ),
    //   });
    // }

    // todo, make this dynamic. No need to do it right now so leaving it for later
    tabs.push({
      label: t('general.attachments'),
      children: renderAttachements(
        Config_UpdateClaimDetails_AttachmentsFormType.DEFAULT
      ),
    });

    return tabs;
  }

  return (
    <Modal
      kind="generic"
      settings={{
        title: t('general.updateClaimDetails'),
        handleClose: handleClose,
      }}
      isLoading={loading}
      className="lg:w-[45.25rem]"
    >
      <div className="p-5">
        <TabsGeneric items={generateTabs()} query={false}></TabsGeneric>
      </div>
    </Modal>
  );
}

export default ModalEditClaimDetails;
